// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application.js'

import ElementController from './element_controller.js'
import AsyncSelectController from './async_select_controller.js'
import TooltipController from './tooltip_controller.js'
import TabsController from './tabs_controller.js'
import ScrollTopController from './scroll_top_controller.js'
import UploadFileController from './upload_file_controller.js'
import AutoSubmitController from './auto_submit_contoller.js'

application.register('element', ElementController)
application.register('async-select', AsyncSelectController)
application.register('tooltip', TooltipController)
application.register('tabs', TabsController)
application.register('scroll-top', ScrollTopController)
application.register('upload-file', UploadFileController)
application.register('auto-submit', AutoSubmitController)
